import { UserNotificationResponseDto } from 'src/app/shared/models/responses/user-notification.response';
import { UiStateStore } from 'src/app/shared/store/ui-state-store.service';
import { SignalrService } from './../../shared/services/signalr.service';
import {
  AfterViewChecked,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { JobInfo } from '../../jobs/models/job-info';
import { ProfileInfo } from '../../shared/models/profile-info';
import { ChatMessage } from '../models/chat-message';
import { ChatService } from '../services/chat.service';
import { UploadStatus } from '../../shared/models/upload-status';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() jobId: string;
  @Input() employerId: string;
  @Input() candidateId: Observable<string>;
  @Input() sender: string;
  @ViewChild('scrollMe') private scrollContainer: ElementRef;

  messages: ChatMessage[] = [];
  chatText: string = '';
  employerProfileInfo: ProfileInfo;
  candidateProfileInfo: ProfileInfo;
  jobInfo: JobInfo;
  currentNotification: UserNotificationResponseDto;
  uploadStatus: string;
  fileName?: string;
  filePath: string;
  private subscriptions: Subscription[] = [];
  private candidateAccountId: string;

  constructor(
    private chatService: ChatService,
    private signalRService: SignalrService,
    private uiState: UiStateStore
  ) {}

  ngOnInit(): void {
    let observables = forkJoin({
      employerProfile: this.chatService.getBusinessInfo(this.employerId),
      jobInfo: this.chatService.getJobInfo(this.jobId),
    });

    this.subscriptions.push(
      observables.subscribe((o) => {
        this.employerProfileInfo = o.employerProfile;
        this.jobInfo = o.jobInfo;
      })
    );

    this.subscriptions.push(
      this.candidateId.subscribe((id) => {
        this.candidateAccountId = id;
        this.chatService.getProfileInfo(id).subscribe((info) => {
          this.candidateProfileInfo = info;
          this.chatService
            .get(
              this.jobId,
              this.employerId,
              this.candidateProfileInfo.accountId
            )
            .subscribe((msg) => {
              this.messages = [];
              this.messages.push(...msg);
              this.scrollToBottom();
            });
        });
      })
    );

    this.subscriptions.push(
      this.uiState.currentNotification$.subscribe((resp) => {
        this.currentNotification = resp;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  onSendClick(): void {
    this.send();
  }

  onKeyDown(event) {
    if (event.keyCode === 13) {
      this.send();
    }
  }

  onDownloadClicked(path: string): void {
    window.open(environment.baseUrl + '/' + path);
  }

  /** CHAT ATTACHMENT FUNCTIONALITY */

  uploadFinished(status: UploadStatus) {
    this.uploadStatus = status.status;
    this.filePath = status.filePath;
    this.fileName = this.filePath.split('\\').pop();

    setTimeout(() => {
      this.uploadStatus = '';
    }, 5000);

    const message = {
      jobid: this.jobId,
      employerid: this.employerId,
      candidateid: this.candidateAccountId,
      message: `<b>Attachment: </b> ${this.fileName}`,
      from: this.sender,
      time: new Date(),
      filePath: this.filePath,
    } as ChatMessage;

    this.chatService.send(message);
  }

  /** CHAT ATTACHMENT FUNCTIONALITY */

  private send(): void {
    const message = {
      jobid: this.jobId,
      employerid: this.employerId,
      candidateid: this.candidateAccountId,
      message: this.chatText,
      from: this.sender,
      time: new Date(),
    } as ChatMessage;
    this.chatService.send(message);
    this.signalRService.saveMessageToNotification(message);
    this.chatText = '';
  }

  private scrollToBottom(): void {
    this.scrollContainer.nativeElement.scrollTop =
      this.scrollContainer.nativeElement.scrollHeight;
  }
}
